import { withStyles } from '@material-ui/core';

import PopupContentForm from './component';
import styles from './styles';

export default withStyles(styles)(PopupContentForm);
